import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";
import { PasswordInput } from "@/components/PasswordInput";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Palavra-passe atualizada. Já pode entrar.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Nova palavra-passe" subtitle="Defina a sua nova palavra-passe.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div className="space-y-1.5">
          <Label>Nova palavra-passe</Label>
          <PasswordInput required minLength={6} value={password}
            onChange={(e) => setPassword(e.target.value)} testid="reset-password" placeholder="••••••••" />
        </div>
        <Button type="submit" className="w-full rounded-full" disabled={busy || !token} data-testid="reset-submit">
          {busy ? <CircleNotch className="animate-spin" /> : "Guardar"}
        </Button>
        {!token && <p className="text-sm text-destructive">Token em falta ou inválido.</p>}
      </form>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        <Link to="/login" className="font-medium text-primary hover:underline">Voltar</Link>
      </p>
    </AuthShell>
  );
}
